export const complaintsData = [
    { complaint: 'Cold pizza', count: 780 },
    { complaint: 'Not enough cheese', count: 120 },
    { complaint: 'Underbaked or Overbaked', count: 52 },
    { complaint: 'Delayed delivery', count: 1123 },
    { complaint: 'Damaged pizza', count: 321 },
    { complaint: 'Incorrect billing', count: 89 },
    { complaint: 'Wrong size delivered', count: 222 },
  ];
  